export default "__VITE_ASSET__D98dwqPY__"